import React from "react";
import { Check } from "lucide-react";

const SelectionCard = ({
  selected,
  onClick,
  icon,
  label,
  sublabel,
  caption,
  testId,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      aria-pressed={selected}
      className={`group relative flex flex-col items-center justify-center gap-2 p-4 sm:p-5 rounded-2xl border-2 min-h-[140px] w-full text-center bg-white transition-all touch-manipulation active:scale-[0.98] ${
        selected
          ? "border-terracotta bg-terracotta-light shadow-[0_8px_24px_rgba(200,75,49,0.18)]"
          : "border-border hover:border-terracotta/40 hover:shadow-md"
      }`}
    >
      {selected && (
        <span className="absolute top-2 right-2 inline-flex items-center justify-center h-7 w-7 rounded-full bg-terracotta text-white shadow">
          <Check className="h-4 w-4" strokeWidth={3} />
        </span>
      )}
      <div
        className={`flex items-center justify-center h-14 w-14 rounded-2xl ${
          selected ? "bg-terracotta/10 text-terracotta" : "bg-sand-alt text-neem"
        }`}
      >
        {icon}
      </div>
      <div className="mt-1">
        <div
          className={`text-base sm:text-lg font-bold leading-tight ${
            selected ? "text-terracotta" : "text-foreground"
          }`}
        >
          {label}
        </div>
        {sublabel && (
          <div className="text-sm text-muted-foreground">{sublabel}</div>
        )}
        {caption && (
          <div className="mt-1 text-[11px] uppercase tracking-wider text-muted-foreground">
            {caption}
          </div>
        )}
      </div>
    </button>
  );
};

export default SelectionCard;
